var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1171275110(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3311,
    cy: 23.3314,
    r: 23.3311,
    fill: "#FCC65A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1668 24.917V21.2503C32.1668 16.667 30.3335 14.8336 25.7502 14.8336H20.2502C15.6668 14.8336 13.8335 16.667 13.8335 21.2503V26.7503C13.8335 31.3336 15.6668 33.167 20.2502 33.167H23.9168",
    stroke: "white",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1668 24.917V21.2503C32.1668 16.667 30.3335 14.8336 25.7502 14.8336H20.2502C15.6668 14.8336 13.8335 16.667 13.8335 21.2503V26.7503C13.8335 31.3336 15.6668 33.167 20.2502 33.167H23.9168",
    stroke: "white",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1668 24.917V21.2503C32.1668 16.667 30.3335 14.8336 25.7502 14.8336H20.2502C15.6668 14.8336 13.8335 16.667 13.8335 21.2503V26.7503C13.8335 31.3336 15.6668 33.167 20.2502 33.167H23.9168",
    stroke: "white",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 30.8111L28.1148 32.2503L31.2498 28.5836",
    stroke: "white",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4165 22.6252V25.3752",
    stroke: "white",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22.6252V25.3752",
    stroke: "white",
    strokeWidth: 1.17857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5835 22.6252V25.3752",
    stroke: "white",
    strokeWidth: 1.17857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171275110);
export default __webpack_public_path__ + "static/media/Group 1171275110.ae5c9223b8fe13fbb917ecdec4d8febc.svg";
export { ForwardRef as ReactComponent };